<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? '':''">
  @if (!isMobile) {
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'MyPriceFileNavNode'"></app-my-account-left-sidenav>
    </div>
  }

  @if (url) {
    <div class="myAccountMyProfile "
      [ngClass]="isMobile? 'col-12' :'col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav'">
      <h1 class="myProfileTopHeader m-0">{{'common.price_download_files'|cxTranslate}}
      </h1>
      <div class="myProfileBody mypriceListBody">
        <div class="mt-2 mb-1 fs-18"><b>{{'common.price_download_files'|cxTranslate}}</b></div>
        <div class="mb-4 fs-18">{{'common.price_here_download_files'|cxTranslate}}</div>
        <div class="mb-5 fs-18">{{'common.price_to_use_feature'|cxTranslate}}</div>
        @if (url?.media.length > 0 ) {
          <div class="mt-5">
            <div class="customer_ID_Li my-2" (click)="selectingAll()">
              <span>
                <input type="checkbox" [(ngModel)]="selectAll">
              </span>
              <div class="ml-2 grey">{{'common.price_select_all'|cxTranslate}}</div>
            </div>
            <div class="scroller">
              @for (each of url.media; track each; let i = $index) {
                <div class="customer_ID_Li">
                  <span>
                    <input type="checkbox" [(ngModel)]="Pricing[i]">
                  </span>
                  <div class="ml-2 grey">{{(each?.code)}}</div>
                </div>
              }
            </div>
          </div>
          <button (click)="downloadFiles()"
            class="btn btn-primary priceList-btn fs-20 mt-5">{{'common.price_download_files'|cxTranslate}}
            <img src="/icons/link-white.svg" style="width: 20px;" alt="">
          </button>
        } @else {
          <p style="margin-top: 255px;">{{'common.no_price_file_to_download'|cxTranslate}}</p>
        }
      </div>
    </div>
  }
</div>